import { resources } from "../config/resources";
import { canOpenRoute } from "./permissions";

// Words for the activity log: kind of item, field names and where each row leads.
// The server stores only field names, never values (see backend/activity_details.py).

export const ENTITY_LABELS = {
  vehicles: "Veicolo", assignments: "Noleggio", quotes: "Preventivo", assignees: "Cliente",
  maintenances: "Manutenzione", deadlines: "Scadenza", costs: "Costo", refuelings: "Rifornimento",
  damages: "Danno", fines: "Multa", suppliers: "Fornitore", locations: "Sede", users: "Utente",
  notifications: "Avvisi",
};

// Groups offered by the "Tipo" filter, each sent as the server's item kinds.
export const ENTITY_GROUPS = [
  ["vehicles", "Veicoli", ["vehicles"]],
  ["rentals", "Preventivi e noleggi", ["quotes", "assignments"]],
  ["customers", "Clienti", ["assignees"]],
  ["fleet", "Manutenzioni, scadenze, costi, danni e multe", ["maintenances", "deadlines", "costs", "refuelings", "damages", "fines"]],
  ["company", "Utenti, sedi e fornitori", ["users", "locations", "suppliers"]],
];

const PAGES = {
  maintenances: "/manutenzioni", deadlines: "/scadenze", costs: "/costi", refuelings: "/rifornimenti",
  damages: "/danni", fines: "/multe", suppliers: "/fornitori", locations: "/sedi", users: "/utenti", quotes: "/noleggi",
};

// Fields not in the page forms of config/resources.js.
const FIELD_LABELS = {
  plate: "Targa", brand: "Marca", model: "Modello", version: "Versione", category: "Categoria", vin: "Numero telaio",
  fuel: "Alimentazione", gearbox: "Cambio", color: "Colore", mileage_current: "Chilometraggio", status: "Stato",
  location_id: "Sede", ownership: "Proprietà", supplier_id: "Fornitore", purchase_price: "Prezzo acquisto",
  current_value: "Valore attuale", contract_end: "Scadenza contratto", keys_count: "Numero chiavi", photos: "Foto",
  documents: "Documenti", attachments: "Allegati", internal_id: "ID interno", notes: "Note",
  name: "Nome", email: "Email", phone: "Telefono", address: "Indirizzo", tax_code: "Codice fiscale",
  vat_number: "Partita IVA", pec: "PEC", recipient_code: "Codice destinatario", customer_kind: "Tipo cliente",
  contacts: "Referenti", drivers: "Conducenti",
  vehicle_id: "Veicolo", assignee_id: "Cliente", start_date: "Inizio", end_date_planned: "Fine prevista",
  end_date_actual: "Fine effettiva", start_at: "Ora di ritiro", end_at: "Ora di rientro", km_start: "Km alla consegna",
  km_end: "Km al rientro", fuel_start: "Carburante alla consegna", fuel_end: "Carburante al rientro",
  monthly_fee: "Canone", agreed_amount: "Importo concordato", conditions: "Condizioni", km_terms: "Km inclusi",
  current_agreement: "Accordo", finance: "Pagamenti", pickup_site_id: "Sede di ritiro", return_site_id: "Sede di riconsegna",
  preparation_minutes: "Preparazione", purpose: "Motivo", internal_note: "Nota interna",
};

export function fieldLabel(entity, key) {
  const field = resources[entity]?.fields?.find((f) => f.key === key);
  return field?.label || FIELD_LABELS[key] || key.replace(/_/g, " ");
}

export const changedText = (row) => (row.changed_fields || []).map((key) => fieldLabel(row.entity, key)).join(", ");

/** The page that shows the item, when this person may open it. */
export function activityLink(row, user) {
  const rental = row.rental_id || (row.entity === "assignments" ? row.entity_id : null);
  const client = row.client_id || (row.entity === "assignees" ? row.entity_id : null);
  const vehicle = row.vehicle_id || (row.entity === "vehicles" ? row.entity_id : null);
  const candidates = [
    rental && `/noleggi/${rental}`,
    row.entity === "assignees" && client && `/clienti/${client}`,
    vehicle && `/veicoli/${vehicle}`,
    PAGES[row.entity],
  ].filter(Boolean);
  return candidates.find((to) => canOpenRoute(user, to)) || null;
}

/** Colour of the dot: created, changed, removed, handovers and requests. */
export function activityTone(action) {
  if (["crea", "duplica", "prenota", "contratto"].includes(action)) return "tone-green";
  if (["archivia", "elimina", "annulla", "rifiuta"].includes(action)) return "tone-red";
  if (["richiesta", "trasferisce", "sostituisce", "proroga"].includes(action)) return "tone-amber";
  return "tone-sky";
}
